import React from 'react';
import {
    Menu,
    MenuItem,
    MenuButton,
    MenuDivider
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import menu from '../image/menu-icon-white.svg'
import { BrowserRouter as Router, Link, } from "react-router-dom";
import QuotePage from '../Pages/QuotePage';
import { ListItemIcon } from '@material-ui/core';


const MenuComponent = () => {
    return ( 
        <div className= 'menu'>
        <Menu menuButton= {<img src = {menu}></img>} direction = 'left'>
            <MenuItem href ='/'>Home </MenuItem>
            <MenuItem href ='/browse'>Browse</MenuItem>
            <MenuItem href ='/random-book'>Random Books</MenuItem>
           
            <MenuDivider className = 'divider'></MenuDivider>
            
             <MenuItem href ='/about-us'>About Us</MenuItem>
            <MenuItem href ='/contact'>Contact</MenuItem>
            <MenuItem href ='/imprint'>Imprint</MenuItem>
            
            <MenuItem id='copyright' href ='/imprint'><font  color='#808080'>©2022 Glimbay</font></MenuItem>
        </Menu>
        </div>
     );
}
 
export default MenuComponent;